import React from 'react'

import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import AbstractDocument from '../Abstract/AbstractDocument'

const Video = function () {
  return (
    <AbstractDocument
      singleCollectionName="Video"
      notToShow={[
        ...SLIDE_FIELDS,
        ...HOMEPAGE_FIELDS,
        ...LOCAL_BUSINESS_FIELDS,
      ]}
      update={false}
    />
  )
}
export default Video
